      const elements = document.querySelectorAll('.animated-scroll-text p');
      var speed = 0;
      elements.forEach(parentElement => {
        const words = parentElement.innerText.trim().split(' ');
        parentElement.innerHTML = '';
        speed = parentElement.closest('.animated-scroll-text').dataset.speed;

        words.forEach((word, i) => {
          const span = document.createElement('span');
          span.style.opacity = 0.2;
          span.style.transition = 'opacity 0.4s ease'; // 👈 fade transition
          span.textContent = word + ' ';
          parentElement.appendChild(span);
        });
      });

function updateOpacity() {
  elements.forEach(parentElement => {
    const spans = parentElement.querySelectorAll('span');
    const rect = parentElement.getBoundingClientRect();
    const vh = Number(speed);
    const viewportHeight = window.innerHeight;

    /*
      Start animation when text ENTERS viewport
      Progress increases as it moves UP
    */
    let progress = (viewportHeight - rect.top) / vh;

    progress = Math.max(0, Math.min(1, progress));

    const count = Math.ceil(progress * spans.length);

    spans.forEach((span, index) => {
      span.style.opacity = index < count ? 1 : 0.2;
    });
  });
}



      window.addEventListener('scroll', updateOpacity);
      window.addEventListener('resize', updateOpacity);
      updateOpacity();